// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","976":"c16184b3"}[chunkId] + "-" + {"678":"6be08d1e7827d7784081","976":"9e974976ed9c7e9b858d"}[chunkId] + ".js";
};